import React from 'react'
import Navbar from '../navbar/Navbar';
import Footer from "../footer/Footer";
import archi1 from "../../interior_assets/architectureimage/architecture1.jpeg";
import archi2 from "../../interior_assets/architectureimage/architecture2.jpeg";

function Architecture() {
//     const [isExpanded, setIsExpanded] = useState(false);

//     const text = `At First Sky Infra Interior, we believe that great interior design starts with 
//     understanding your needs and vision. Our expert team blends functionality with aesthetics to 
//     create spaces that reflect your style and purpose. From concept to execution, we ensure every 
//     detail aligns with your expectations, using high-quality materials and innovative designs. 
//     Whether it’s a modern office, a luxury home, or a commercial space, we craft interiors that 
//     are both beautiful and practical—designed just for you, with complete satisfaction.`;
//     <div style={{ maxWidth: "100vw", textAlign: "justify" }}>
//     <p style={{ textIndent: "30px", display: "-webkit-box", WebkitLineClamp: isExpanded ? "unset" : "2", WebkitBoxOrient: "vertical", overflow: "hidden" }}>
//         {text}
//     </p>
//     <button onClick={() => setIsExpanded(!isExpanded)} style={{ background: "none", border: "none", color: "blue", cursor: "pointer", padding: 0 }}>
//         {isExpanded ? "Read Less" : "Read More"}
//     </button>
// </div>

    return (
        <>
            <Navbar />
            <section style={{ marginTop: "80px" }}>
                <div className='container' style={{ padding: "10px 20px" }}>
                    <h3>Architecture</h3>
                    <p style={{ textIndent: "30px" }}>At First Sky Infra Interior , we believe that great interior design starts with
                        understanding your needs and vision. Our expert team blends functionality with
                        aesthetics to create spaces that reflect your style and purpose. From concept to
                        execution, we ensure every detail aligns with your expectations, using high-quality
                        materials and innovative designs. Whether it’s a modern office, a luxury home, or a
                        commercial space, we craft interiors that are both beautiful and practical—designed just for you, with complete satisfaction.</p>

                    <ul style={{ listStyle:"auto"}}>
                        <li> Client Consultation & Understanding Needs</li>
                        <li> Site Visit & Measurements</li>
                        <li>Budget Planning & Quality Assurance</li>
                        <li>Customized Design & Client Collaboration</li>
                        <li>Execution & Continuous Supervision</li>
                        <li>Final Review & Project Handover</li>
                    </ul>
                </div>

                <div className="container  vm-container-project" style={{ display: "flex" }}>
                    <div className="image-container-vm">
                        <img src={archi1} alt="Your Image" className="image-vm" />
                    </div>
                    <div className="text-container">
                        <div className="vision">
                            <h6 style={{ color:"#073003", fontWeight:"bolder", textTransform:"uppercase" , fontSize:"19px"}}>Client Consultation & Understanding Needs:</h6>
                            <p style={{ textIndent: "30px", textAlign: "justify" }}>
                                We begin by discussing your requirements, preferences, and expectations to craft a personalized design plan.                           </p>
                            <h6 style={{ color:"#073003", fontWeight:"bolder", textTransform:"uppercase" , fontSize:"19px"}}> Site Visit & Measurements:</h6>
                            <p style={{ textIndent: "30px", textAlign: "justify" }}>
                                Our team conducts a detailed site analysis and takes precise measurements to ensure accurate planning and execution.                           </p>

                            <h6 style={{ color:"#073003", fontWeight:"bolder", textTransform:"uppercase" , fontSize:"19px"}}> Budget Planning & Quality Assurance:</h6>
                            <p style={{ textIndent: "30px", textAlign: "justify" }}>
                                We align the project with your budget while maintaining the highest standards of quality and design excellence.                               </p>
                        </div>

                    </div>
                </div>

                <div className="about-us-container" style={{ marginTop: "-10px"}}>
                        <div className="about-us-content">
                          <div className="left-side">
                            <h6 style={{ color:"#073003", fontWeight:"bolder", textTransform:"uppercase" , fontSize:"19px"}}>Customized Design & Client Collaboration:</h6>
                            <p style={{ textIndent: "30px", textAlign: "justify" }}>
                            Our experts create a design plan tailored to your needs, ensuring it reflects your style and functional requirements.                                           </p>
                            <h6 style={{ color:"#073003", fontWeight:"bolder", textTransform:"uppercase" , fontSize:"19px"}}>Execution & Continuous Supervision:</h6>
                            <p style={{ textIndent: "30px", textAlign: "justify" }}>
                            From material selection to installation, we meticulously manage every stage to ensure a seamless transformation.                                          </p>
                            <h6 style={{ color:"#073003", fontWeight:"bolder", textTransform:"uppercase" , fontSize:"19px"}}>Final Review & Project Handover:</h6>
                            <p style={{ textIndent: "30px", textAlign: "justify" }}>
                            Your satisfaction is our priority! We ensure every element is as per your expectations before delivering your dream space on time.                                                                   </p>
                          
                          </div>
                          <div className="right-side">
                            <div className="image-container">
                              <img src={archi2} alt="Construction Site" className="large-image" />
                            </div>
                          </div>
                        </div>
                      </div>
            </section>
            <Footer />
        </>
    )
}

export default Architecture